module.exports = __webpack_public_path__ + "static/media/tartine-olo-small.8dd05a64.png";